export const CardStatus = ({ status }: { status: string }) => {
  const classname = (status.includes(" ") ? status.replace(" ", "_") : status).toLowerCase()
  return <span className={`card_status_label ${classname}`}>{status.toLowerCase()}</span>
}
